// @packages
import Box from '@material-ui/core/Box';
import React from 'react';

// @scripts
import IconButton from '../controls/toolkit/ctrl-icon-button';

const Toolbar = ({ options }) => (
    <Box mt={7}>
        {options.map(({
            disabled,
            icon,
            onClick,
            title,
            visible
        }, index) => (
            <IconButton
                disabled={disabled}
                icon={`fa ${icon}`}
                key={index}
                onClick={onClick}
                title={title}
                visible={visible}
            />
        ))}
    </Box>
);

export default Toolbar;
